module.exports = __webpack_public_path__ + "img/Km3FO09.08822a80.png";